<script lang="ts">
  import type { Snippet } from "svelte";

  let {
    tone = "danger",
    children,
  }: {
    tone?: "danger" | "ok" | "info";
    children: Snippet;
  } = $props();

  const toneClass: Record<string, string> = {
    danger: "bg-danger-bg text-danger border-danger-border",
    ok: "bg-success-bg text-success border-success-border",
    info: "bg-brand-soft text-brand-strong border-brand-border",
  };
</script>

<div
  data-tone={tone}
  class="text-sm font-medium px-3.25 py-2.5 rounded-md border {toneClass[tone]}"
  role="status"
>
  {@render children()}
</div>
